import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {FetchStatus} from '../common/FetchStatus.enum';
import {ERROR_STATE_NAME} from './constants';
import {AvailableErrorType, ErrorsState} from './ErrorsState.interface';

export const INITIAL_STATE = {
  sampleError: {fetchStatus: FetchStatus.Idle},
  errorList: [],
} as ErrorsState;

export const errorsSlice = createSlice({
  name: ERROR_STATE_NAME,
  initialState: INITIAL_STATE,
  reducers: {
    clearError: (state): void => {
      state.errorList = [];
    },
    addError: (
      state,
      action: PayloadAction<{error: AvailableErrorType}>
    ): void => {
      const {error} = action.payload;
      state.errorList.push(error);
    },
  },
});

export const {clearError, addError} = errorsSlice.actions;
